import { Stack, Typography } from '@mui/material';

import useResponsive from '@app/hooks/use-responsive';

const NutritionTab = ({ data }: any) => {
  const isMobile = useResponsive('down', 'sm');

  const keyValueArray = Object.entries(data)
    .map(([key, value]) => `${key}: ${value}`)
    .map((item) => {
      const [key, value] = item.split(': ').map((part) => part.trim());
      return { key, value: parseFloat(value).toFixed(2) };
    });
  return (
    <Stack m={4}>
      {data &&
        keyValueArray?.map((item: any, index: any) => {
          return (
            <Stack
              key={index}
              sx={[styles.ingredientContainer, { width: isMobile ? '100%' : '50%' }]}
            >
              <Stack sx={styles.ingredientNameContainer}>
                <Typography variant="subtitle2">{item?.key}</Typography>
              </Stack>
              <Typography variant="caption">{item.value} </Typography>
            </Stack>
          );
        })}
    </Stack>
  );
};

const styles = {
  ingredientContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  ingredientNameContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '80%',
    marginY: 1,
  },
  ingredientImageStyles: {
    height: '24px',
    width: '24px',
    marginRight: '20px',
  },
};
export { NutritionTab };
